var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 41.25,
    height: 41.25,
    rx: 7.875,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 41.25,
    height: 41.25,
    rx: 7.875,
    stroke: "#E7E8E9",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4474 17.0703L25.9199 27.2178C25.7399 27.9753 25.0649 28.5002 24.2849 28.5002H14.4299C13.2974 28.5002 12.4874 27.3902 12.8249 26.3027L15.9824 16.1628C16.1999 15.4578 16.8524 14.9702 17.5874 14.9702H26.8124C27.5249 14.9702 28.1174 15.4052 28.3649 16.0052C28.5074 16.3277 28.5374 16.6953 28.4474 17.0703Z",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28.5H27.585C28.5525 28.5 29.31 27.6825 29.2425 26.715L28.5 16.5",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.26 16.7849L20.04 13.5449",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2849 16.7926L24.9899 13.5376",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7749 21H23.7749",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0249 24H23.0249",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPopup);
export default __webpack_public_path__ + "static/media/CalendarPopup.0d419d45d5051bb83e45e9a0e4fecfaa.svg";
export { ForwardRef as ReactComponent };